import { Menu, useMenuContext } from '@shared/components/Menu';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { TagOptionPill } from './TagOptionPill';
import { TagOptionsProps, getSearchPlaceholder } from './tagOptions';

type TagOption = API.TagComponentOption;

/**
 * Radio rows. Picking a tag selects only it and closes the menu; picking the selected tag again
 * clears the field, unless it's required.
 */
export function TagSingleSelectOptions({
  options,
  selectedValues,
  onChange,
  filter,
  setFilter,
  canCreate,
  isRequired = false,
}: TagOptionsProps) {
  const { close } = useMenuContext();
  const query = filter.toLowerCase();

  const onSelect = (option: TagOption) => {
    const isSelected = selectedValues.length === 1 && selectedValues[0] === option.value;
    onChange(isSelected && !isRequired ? [] : [option.value]);
    close();
  };

  return (
    <Menu.SearchableOptions
      filter={filter}
      setFilter={setFilter}
      searchPlaceholder={getSearchPlaceholder(canCreate)}
      options={options.filter(option => (option.label ?? '').toLowerCase().includes(query))}
      getItemKey={option => option.value}
      getItemLabel={option => option.label ?? ''}
      getItemContent={option => (
        <View flex marginLeft={-0.5} paddingVertical={0.5} paddingRight={2}>
          <TagOptionPill option={option} />
        </View>
      )}
      isItemSelected={option => selectedValues.includes(option.value)}
      onSelect={onSelect}
      radio
    />
  );
}
